import React from 'react';
import {
    Switch,
    Route,
    withRouter,
    useRouteMatch,
    useParams
} from "react-router-dom";
import MasterExam from './page-content/admin/MasterExam';
import MasterPatient from './page-content/admin/MasterPatient';
import MasterKonsultasi from './page-content/admin/MasterKonsultasi';
import MasterDokterKonsultasi from './page-content/admin/MasterDokterKonsultasi';
import MasterDokter from './page-content/admin/MasterDokter';
import MasterFinance from './page-content/admin/MasterFinance';
import MasterUsers from './page-content/admin/MasterUsers';
import MasterLog from './page-content/admin/MasterLog';
import './page-content/dashboard.css';

function PostType() {
    let match = useRouteMatch();
    let { postType } = useParams();
    if (postType === "") {
        localStorage.setItem("path", "PESERTA");
    } else {
        localStorage.setItem("path", postType.toUpperCase());
    }

    // if (postType === 'master-record') {
    //     localStorage.setItem("_interval", true);
    //     return (
    //         <Switch>
    //             <Route path={match.path}>
    //                 <MasterPatient />
    //             </Route>
    //         </Switch>
    //     );
    // }

    if (postType === 'master-exam') {
        localStorage.setItem("_interval", true);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterExam />
                </Route>
            </Switch>
        );
    } else if (postType === 'master-record') {
        localStorage.setItem("_interval", true);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterPatient />
                </Route>
            </Switch>
        );
    } else if (postType === 'master-konsultasi') {
        localStorage.setItem("_interval", false);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterKonsultasi />
                </Route>
            </Switch>
        );
    } else if (postType === 'master-dokter') {
        localStorage.setItem("_interval", false);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterDokter />
                </Route>
            </Switch>
        );
    } else if (postType === 'penugasan-konsultasi') {
        localStorage.setItem("_interval", false);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterDokterKonsultasi />
                </Route>
            </Switch>
        );
    } else if (postType === 'laporan-finance') {
        localStorage.setItem("_interval", false);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterFinance />
                </Route>
            </Switch>
        );
    } else if (postType === 'master-users') {
        localStorage.setItem("_interval", false);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterUsers />
                </Route>
            </Switch>
        );
    } else if (postType === 'master-log') {
        localStorage.setItem("_interval", false);
        return (
            <Switch>
                <Route path={match.path}>
                    <MasterLog />
                </Route>
            </Switch>
        );
    }
    else {
        return <h3>Not Found</h3>;
    }
}

export default withRouter(PostType);